import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPlayerWrapper from './reactPlayerWrapper.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { validate, mergeStyles, isSSR } from 'wix-rich-content-common';
import pluginVideoSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import { isEqual } from 'lodash';
import getVideoSrc from './get-video-source.js';
import IframePlayer from './IframePlayer.js';
import { s as styles } from './video-viewer-5a066449.js';
import 'react-player';
import './constants.js';
import 'ricos-schema';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VideoViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "setUrl", (newUrl) => {
      var _a, _b;
      const url = this.normalizeUrl(newUrl);
      if (url !== this.state.url) {
        this.setState({ url });
        (_b = (_a = this.props).onReload) == null ? void 0 : _b.call(_a);
      }
    });
    __publicField(this, "normalizeUrl", (url) => url.toLowerCase().indexOf("vimeo") === 0 ? "https://" + url : url);
    //vimeo player needs urls prefixed with http[s]
    __publicField(this, "findFormalVideoRatio", (ratio) => {
      const baseRatios = [1, 5 / 4, 4 / 3, 3 / 2, 16 / 10, 16 / 9, 1.85, 2, 2.35, 2.39, 3];
      const videoRatios = [...baseRatios, ...baseRatios.map((x) => 1 / x)];
      const findClosest = (arr, target) => arr.reduce((prev, curr) => Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev);
      const closest = findClosest(videoRatios, ratio);
      return Math.abs(closest - ratio) > 0.01 ? ratio : closest;
    });
    __publicField(this, "onReactPlayerReady", (player) => {
      var _a, _b;
      if (!this.props.isLoaded) {
        ((_b = (_a = this.props).onReady) == null ? void 0 : _b.call(_a, player)) || this.setState({ isLoaded: true });
      }
    });
    __publicField(this, "handleContextMenu", (e) => this.props.componentData.disableDownload && e.preventDefault());
    __publicField(this, "disableDownloadProps", () => {
      const { componentData, settings } = this.props;
      const disableProps = {
        config: {
          file: {
            attributes: {
              controlsList: "nodownload"
            }
          }
        }
      };
      let disable = {};
      if (componentData.disableDownload !== void 0) {
        disable = componentData.disableDownload ? disableProps : {};
      } else if (settings.disableDownload !== void 0) {
        disable = settings.disableDownload ? disableProps : {};
      }
      return disable;
    });
    __publicField(this, "onProgress", (progress) => {
      var _a;
      const { settings, blockKey } = this.props;
      (_a = settings.onProgress) == null ? void 0 : _a.call(settings, __spreadProps(__spreadValues({}, progress), { id: blockKey }));
    });
    validate(props.componentData, pluginVideoSchema);
    this.state = { url: void 0, isLoaded: false, isVideoWrapperAttachedToDom: false };
    const url = getVideoSrc(props.componentData.src, props.settings);
    if (typeof url === "string") {
      this.state = { url: this.normalizeUrl(url) };
    } else if (url && typeof url.then === "function") {
      url.then((url2) => this.setState({ url: this.normalizeUrl(url2) }));
    }
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginVideoSchema);
      if (!isEqual(nextProps.componentData.src, this.props.componentData.src)) {
        const url = getVideoSrc(nextProps.componentData.src, nextProps.settings);
        if (typeof url === "string") {
          this.setUrl(url);
        } else if (url && typeof url.then === "function") {
          url.then((url2) => this.setUrl(url2));
        }
      }
    }
  }
  componentDidMount() {
    this.setState({ key: "mounted" });
  }
  componentDidUpdate() {
    const { isVideoWrapperAttachedToDom } = this.state;
    if (!isVideoWrapperAttachedToDom) {
      const videoRatio = this.getVideoRatio();
      if (videoRatio) {
        this.setVideoRatio(videoRatio.ratio, videoRatio.wrapper);
        this.setState({ isVideoWrapperAttachedToDom: true });
      }
    }
  }
  getVideoRatio() {
    var _a;
    const wrapper = (_a = ReactDOM.findDOMNode(this)) == null ? void 0 : _a.parentNode;
    if (!wrapper) {
      return void 0;
    }
    const element = wrapper.querySelector("iframe, video");
    if (!element) {
      return void 0;
    }
    const ratio = element.clientHeight / element.clientWidth;
    return !isNaN(ratio) ? { ratio, wrapper } : void 0;
  }
  setVideoRatio(ratio, wrapper) {
    wrapper.style["padding-bottom"] = ratio * 100 + "%";
  }
  render() {
    const {
      theme,
      width,
      height,
      disabled,
      setComponentUrl,
      onDuration,
      settings,
      muted,
      componentData,
      seoMode
    } = this.props;
    this.styles = this.styles || mergeStyles({ styles, theme });
    const { url, key } = this.state;
    setComponentUrl == null ? void 0 : setComponentUrl(url);
    const isLoaded = this.props.isLoaded || this.state.isLoaded;
    const isCustomVideo = typeof componentData.src === "object";
    const shouldRenderIframe = isSSR() && seoMode;
    const {
      autoPlay = false,
      playInLoop = false,
      showControls = true
    } = componentData.options || {};
    const props = __spreadValues({
      url,
      onReady: this.onReactPlayerReady,
      disabled,
      width,
      height,
      key,
      onDuration,
      onProgress: this.onProgress,
      progressInterval: settings.progressInterval || 1e3,
      muted: muted || autoPlay,
      isLoaded,
      autoPlay,
      loop: playInLoop,
      isCustomVideo
    }, this.disableDownloadProps());
    return shouldRenderIframe ? /* @__PURE__ */ React.createElement(IframePlayer, { isCustomVideo, url }) : /* @__PURE__ */ React.createElement(
      ReactPlayerWrapper,
      __spreadValues({
        className: classNames(this.styles.video_player),
        onContextMenu: this.handleContextMenu,
        controls: this.props.isLoaded !== false && showControls
      }, props)
    );
  }
}
VideoViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  onStart: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  settings: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  setComponentUrl: PropTypes.func,
  onReady: PropTypes.func,
  isLoaded: PropTypes.bool,
  onReload: PropTypes.func,
  onDuration: PropTypes.func,
  blockKey: PropTypes.string,
  muted: PropTypes.bool,
  seoMode: PropTypes.bool
};
VideoViewer.defaultProps = {
  width: "100%",
  height: "100%"
};

export { VideoViewer as default };
//# sourceMappingURL=video-viewer.js.map
